import { render, staticRenderFns } from "./CollectedDataTable.vue?vue&type=template&id=469bd5ea&scoped=true&"
import script from "./CollectedDataTable.vue?vue&type=script&lang=js&"
export * from "./CollectedDataTable.vue?vue&type=script&lang=js&"
import style0 from "./CollectedDataTable.vue?vue&type=style&index=0&id=469bd5ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469bd5ea",
  null
  
)

export default component.exports